import { inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { StoreService } from '../services/store.service';
import { TruckDistributionService } from '../services/truck-distribution.service';

@Injectable({
	providedIn: 'root',
})
export class CanLeavePageCustomGuard implements CanDeactivate<unknown> {
	private _router = inject(Router);
	private _truckDistribution = inject(TruckDistributionService);
	// private
	constructor() {}
	canDeactivate(
		component: unknown,
		currentRoute: ActivatedRouteSnapshot,
		currentState: RouterStateSnapshot,
		nextState?: RouterStateSnapshot,
	): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		if (!this._truckDistribution.canLeaveCurrentPage) {
			this._router.navigate([currentState.url.slice(1)]);

			return false;
		}

		return true;
	}
}
